var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('z-button',{attrs:{"data-test-id":"download-btn","variant":"secondary","fit":"auto","size":"md","disabled":_vm.loading,"loading":_vm.loading},on:{"click":_vm.downloadCSV}},[_c('font-awesome-icon',{attrs:{"icon":"download"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }